<template>
  <qc-bubble popup-class="msg-bubble" :show="showBubble" :offset="-10" :appendToBody="false" placement="bottom">
    <template slot="popup">
      <div class="msg-bubble__text">
        {{ msgBubbleText }} <qc-icon class="btn-msg-close" type="close" @click="closeBubble" />
      </div>
    </template>

    <div class="msg-bubble__trigger" />
  </qc-bubble>
</template>


<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    msgBubbleText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showBubble: false,
    };
  },
  watch: {
    isShow: {
      handler(newVal) {
        this.showBubble = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    closeBubble() {
      this.showBubble = false;
    },
  },
};
</script>


<style>
.msg-bubble {
  margin-left: -16px;
}
.msg-bubble__text {
  font-size: 14px;
  white-space: nowrap;
}
.msg-bubble .btn-msg-close {
  vertical-align: -3px;
  margin-left: 5px;
  cursor: pointer;
  transform: scale(0.8);
}
/* reset bubble组件style */
.msg-bubble .tc-15-bubble-inner {
  border: 0 none;
  border-radius: 2px;
  padding: 8px 12px;
  box-shadow: 0 0 10px 2px rgba(0,0,0,0.1);
}
</style>
